import React, { useState } from 'react';
import { PromiseOr } from '../../util/types.util';
import { LoadingSpinner } from '../components/LoadingSpinner';
import * as Icons from './svg';

export enum IconType {
  activity = 'ActivityIcon',
  alertCircle = 'AlertCircleIcon',
  checkCircle = 'CheckCircleIcon',
  check = 'CheckIcon',
  xClose = 'XCloseIcon',
  chevronDown = 'ChevronDownIcon',
  mail1 = 'Mail1Icon',
  file4 = 'File4Icon',
  filePlus2 = 'FilePlus2Icon',
  arrowNarrowLeft = 'ArrowNarrowLeftIcon',
  infoCircle = 'InfoCircleIcon',
  uploadCloud2 = 'UploadCloud2Icon',
  share4 = 'Share4Icon',
  building7 = 'Building7Icon',
  container = 'ContainerIcon',
  package = 'PackageIcon',
  logOut1 = 'LogOut1Icon',
  plusCircle = 'PlusCircleIcon',
  infoHexagon = 'InfoHexagonIcon',
  markerPin1 = 'MarkerPin1Icon',
  searchLg = 'SearchLgIcon',
  download1 = 'Download1Icon',
  chevronLeft = 'ChevronLeftIcon',
  chevronRight = 'ChevronRightIcon',
  arrowLeft = 'ArrowLeftIcon',
  arrowRight = 'ArrowRightIcon',
  diamond1 = 'Diamond1Icon',
  annotationAlert = 'AnnotationAlertIcon',
  plus = 'PlusIcon',
  filter = 'FilterIcon',
  edit2 = 'Edit2Icon',
  alertTriangle = 'AlertTriangleIcon',
  upload1 = 'Upload1Icon',
  settings1 = 'Settings1Icon',
  userPlus1 = 'UserPlus1Icon',
  trash1 = 'Trash1Icon',
  camera1 = 'Camera1Icon',
  eye = 'EyeIcon',
  x = 'XIcon',
  dataFlow1 = 'DataFlow1Icon',
  dotsVertical = 'DotsVerticalIcon',
  wallet1 = 'Wallet1Icon',
  key1 = 'Key1Icon',
  refreshCw5 = 'RefreshCw5Icon',
  terminalBrowser = 'TerminalBrowserIcon',
  backpack = 'BackpackIcon',
  settings4 = 'Settings4Icon',
  building3 = 'Building3Icon',
  tag1 = 'Tag1Icon',
  shoppingBag1 = 'ShoppingBag1Icon',
  briefCase1 = 'BriefCase1Icon',
  switchVertical1 = 'SwitchVertical1Icon',
  switchVertical2 = 'SwitchVertical2Icon',
  arrowDown = 'ArrowDownIcon',
  arrowUp = 'ArrowUpIcon',
  xCircle = 'XCircleIcon',
  truck1 = 'Truck1Icon',
  calendar = 'CalendarIcon',
  link = 'LinkIcon',
  dataFlow4 = 'DataFlow4Icon',
  searchRefraction = 'SearchRefractionIcon',
  imagePlus = 'ImagePlusIcon',
  type01 = 'Type01Icon',
  columns03 = 'Columns03Icon',
  textInput = 'TextInputIcon',
  square = 'SquareIcon',
  fileDownload02Icon = 'FileDownload02Icon',
  arrowBlockRight = 'ArrowBlockRightIcon',
  switchHorizontal01 = 'SwitchHorizontal01Icon',
  copy02 = 'Copy02Icon',
}

export interface IconProps {
  type: IconType;
  /** Sets the role to 'button' if defined */
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => PromiseOr<any>;
  /** Tailwind stroke class */
  stroke?: string;
  /** Tailwind strokeWidth class */
  strokeWidth?: string;
  /** Tailwind fill class */
  fill?: string;
  /** Tailwind size classes */
  size?: string;
  /** Additional tailwind classes */
  className?: string;

  style?: React.CSSProperties;
}

export default function Icon({
  type,
  stroke = 'stroke-inherit',
  strokeWidth = 'stroke-[1.667]',
  fill = 'fill-none',
  size = 'size-6',
  className = '',
  onClick,
  style,
}: IconProps) {
  className = `block ${stroke} ${strokeWidth} ${fill} ${size} ${className}`;

  const [loading, setLoading] = useState(false);

  const icon = Icons[type];

  if (onClick) {
    return (
      <button
        style={style}
        onClick={async event => {
          if (loading) return;
          setLoading(true);
          await onClick(event);
          setLoading(false);
        }}
        className={className}
      >
        {loading ? <LoadingSpinner /> : icon}
      </button>
    );
  }

  return <span className={className}>{icon}</span>;
}
